module.exports = __webpack_public_path__ + "img/1101.c8d9cd44.svg";